import React from "react";

const ShiftBlock = ({ shiftBlock }) => {
  const DAY_COLOUR = "#FDD835";
  const AFTERNOON_COLOUR = "#2196F3";
  const NIGHT_COLOUR = "#1A237E";

  const DAY = "Day";
  const AFTERNOON = "Afternoon";
  const NIGHT = "Night";

  const shiftBlockColours = {
    [DAY]: DAY_COLOUR,
    [AFTERNOON]: AFTERNOON_COLOUR,
    [NIGHT]: NIGHT_COLOUR,
  };

  const mapColour = shiftBlockColours[shiftBlock];

  return <div style={{ color: mapColour || "#4c4c4c" }}>{shiftBlock}</div>;
};

export default ShiftBlock;
